import { SaveFileWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  SchemaProvider,
  WorkflowNodeSchemaProvider,
} from '../../registry/schema-provider.registry';

@WorkflowNodeSchemaProvider('SaveFile')
export class SaveFileNodeSchemaProvider extends SchemaProvider<SaveFileWorkflowNode> {}
